var promise;
var queueMicrotask_1 = typeof queueMicrotask === 'function' ? queueMicrotask : function (cb) {
  return (promise || (promise = Promise.resolve())).then(cb)["catch"](function (err) {
    return setTimeout(function () {
      throw err;
    }, 0);
  });
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var mailbox = function mailbox() {
  var queue = [];
  var next;
  return {
    deliver: function deliver(msg) {
      try {
        queue.push(msg);

        if (next) {
          next(queue.shift());
          next = undefined;
        }

        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    receive: function receive() {
      return new Promise(function innerReceive(resolve) {
        var msg = queue.shift();
        if (msg) return resolve(msg);
        next = resolve;
      });
    }
  };
};

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
}

function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    var observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

var _Pact = /*#__PURE__*/function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;

    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        var value = _this.v;

        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}();

function _isSettledPact(thenable) {
  return thenable instanceof _Pact && thenable.s & 1;
}

function _for(test, update, body) {
  var stage;

  for (;;) {
    var shouldContinue = test();

    if (_isSettledPact(shouldContinue)) {
      shouldContinue = shouldContinue.v;
    }

    if (!shouldContinue) {
      return result;
    }

    if (shouldContinue.then) {
      stage = 0;
      break;
    }

    var result = body();

    if (result && result.then) {
      if (_isSettledPact(result)) {
        result = result.s;
      } else {
        stage = 1;
        break;
      }
    }

    if (update) {
      var updateValue = update();

      if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
        stage = 2;
        break;
      }
    }
  }

  var pact = new _Pact();

  var reject = _settle.bind(null, pact, 2);

  (stage === 0 ? shouldContinue.then(_resumeAfterTest) : stage === 1 ? result.then(_resumeAfterBody) : updateValue.then(_resumeAfterUpdate)).then(void 0, reject);
  return pact;

  function _resumeAfterBody(value) {
    result = value;

    do {
      if (update) {
        updateValue = update();

        if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
          updateValue.then(_resumeAfterUpdate).then(void 0, reject);
          return;
        }
      }

      shouldContinue = test();

      if (!shouldContinue || _isSettledPact(shouldContinue) && !shouldContinue.v) {
        _settle(pact, 1, result);

        return;
      }

      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
        return;
      }

      result = body();

      if (_isSettledPact(result)) {
        result = result.v;
      }
    } while (!result || !result.then);

    result.then(_resumeAfterBody).then(void 0, reject);
  }

  function _resumeAfterTest(shouldContinue) {
    if (shouldContinue) {
      result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
      } else {
        _resumeAfterBody(result);
      }
    } else {
      _settle(pact, 1, result);
    }
  }

  function _resumeAfterUpdate() {
    if (shouldContinue = test()) {
      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
      } else {
        _resumeAfterTest(shouldContinue);
      }
    } else {
      _settle(pact, 1, result);
    }
  }
}

var INIT = "INIT";
var SUBSCRIBE = "SUBSCRIBE";
var UNSUBSCRIBE = "UNSUBSCRIBE";
var UPDATED = "UPDATED";
var EXIT = "EXIT";
var TERMINATE = "TERMINATE";
var root = typeof self === "object" && self.self === self && self || typeof global === "object" && global.global === global && global || typeof window === "object" && window.window === window && window;
root.FCL_REGISTRY = root.FCL_REGISTRY == null ? {} : root.FCL_REGISTRY;
var pid = 0;
var DEFAULT_TIMEOUT = 5000;

var _send = function send(addr, tag, data, opts) {
  if (opts === void 0) {
    opts = {};
  }

  return new Promise(function (reply, reject) {
    var expectReply = opts.expectReply || false;
    var timeout = opts.timeout != null ? opts.timeout : DEFAULT_TIMEOUT;

    if (expectReply && timeout) {
      setTimeout(function () {
        return reject(new Error("Timeout: " + timeout + "ms passed without a response."));
      }, timeout);
    }

    var payload = {
      to: addr,
      from: opts.from,
      tag: tag,
      data: data,
      timeout: timeout,
      reply: reply,
      reject: reject
    };

    try {
      root.FCL_REGISTRY[addr] && root.FCL_REGISTRY[addr].mailbox.deliver(payload);
      if (!expectReply) reply(true);
    } catch (error) {
      console.error("FCL.Actor -- Could Not Deliver Message", payload, root.FCL_REGISTRY[addr], error);
    }
  });
};

var kill = function kill(addr) {
  delete root.FCL_REGISTRY[addr];
};

var fromHandlers = function fromHandlers(handlers) {
  if (handlers === void 0) {
    handlers = {};
  }

  return function (ctx) {
    try {
      var _temp12 = function _temp12() {
        var _loopInterrupt;

        var _temp6 = _for(function () {
          return !_loopInterrupt && 1;
        }, void 0, function () {
          return Promise.resolve(ctx.receive()).then(function (letter) {
            var _temp5 = _finallyRethrows(function () {
              return _catch(function () {
                function _temp4() {
                  return Promise.resolve(handlers[letter.tag](ctx, letter, letter.data || {})).then(function () {});
                }

                var _temp3 = function () {
                  if (letter.tag === EXIT) {
                    var _temp10 = function _temp10() {
                      _loopInterrupt = 1;
                    };

                    var _temp11 = function () {
                      if (typeof handlers[TERMINATE] === "function") {
                        return Promise.resolve(handlers[TERMINATE](ctx, letter, letter.data || {})).then(function () {});
                      }
                    }();

                    return _temp11 && _temp11.then ? _temp11.then(_temp10) : _temp10(_temp11);
                  }
                }();

                return _temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3);
              }, function (error) {
                console.error(ctx.self() + " Error", letter, error);
              });
            }, function (_wasThrown, _result) {
              return;
              if (_wasThrown) throw _result;
              return _result;
            });

            if (_temp5 && _temp5.then) return _temp5.then(function () {});
          });
        });

        var _temp7 = function () {
          if (_temp6 && _temp6.then) return _temp6.then(function () {});
        }();

        if (_temp7 && _temp7.then) return _temp7.then(function () {});
      };

      var _temp13 = function () {
        if (typeof handlers[INIT] === "function") return Promise.resolve(handlers[INIT](ctx)).then(function () {});
      }();

      return Promise.resolve(_temp13 && _temp13.then ? _temp13.then(_temp12) : _temp12(_temp13));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};

var spawn = function spawn(fn, addr) {
  if (addr === void 0) {
    addr = null;
  }

  if (addr == null) addr = ++pid;
  if (root.FCL_REGISTRY[addr] != null) return addr;
  root.FCL_REGISTRY[addr] = {
    addr: addr,
    mailbox: mailbox(),
    subs: new Set(),
    kvs: {},
    error: null
  };
  var ctx = {
    self: function self() {
      return addr;
    },
    receive: function receive() {
      return root.FCL_REGISTRY[addr].mailbox.receive();
    },
    send: function send(to, tag, data, opts) {
      if (opts === void 0) {
        opts = {};
      }

      opts.from = addr;
      return _send(to, tag, data, opts);
    },
    sendSelf: function sendSelf(tag, data, opts) {
      if (root.FCL_REGISTRY[addr]) _send(addr, tag, data, opts);
    },
    broadcast: function broadcast(tag, data, opts) {
      if (opts === void 0) {
        opts = {};
      }

      opts.from = addr;

      for (var _iterator = _createForOfIteratorHelperLoose(root.FCL_REGISTRY[addr].subs), _step; !(_step = _iterator()).done;) {
        var to = _step.value;

        _send(to, tag, data, opts);
      }
    },
    subscribe: function subscribe(sub) {
      return sub != null && root.FCL_REGISTRY[addr].subs.add(sub);
    },
    unsubscribe: function unsubscribe(sub) {
      return sub != null && root.FCL_REGISTRY[addr].subs["delete"](sub);
    },
    subscriberCount: function subscriberCount() {
      return root.FCL_REGISTRY[addr].subs.size;
    },
    hasSubs: function hasSubs() {
      return !!root.FCL_REGISTRY[addr].subs.size;
    },
    put: function put(key, value) {
      if (key != null) root.FCL_REGISTRY[addr].kvs[key] = value;
    },
    get: function get(key, fallback) {
      var value = root.FCL_REGISTRY[addr].kvs[key];
      return value == null ? fallback : value;
    },
    "delete": function _delete(key) {
      delete root.FCL_REGISTRY[addr].kvs[key];
    },
    update: function update(key, fn) {
      if (key != null) root.FCL_REGISTRY[addr].kvs[key] = fn(root.FCL_REGISTRY[addr].kvs[key]);
    },
    keys: function keys() {
      return Object.keys(root.FCL_REGISTRY[addr].kvs);
    },
    all: function all() {
      return root.FCL_REGISTRY[addr].kvs;
    },
    where: function where(pattern) {
      return Object.keys(root.FCL_REGISTRY[addr].kvs).reduce(function (acc, key) {
        var _extends2;

        return pattern.test(key) ? _extends({}, acc, (_extends2 = {}, _extends2[key] = root.FCL_REGISTRY[addr].kvs[key], _extends2)) : acc;
      }, {});
    },
    merge: function merge(data) {
      if (data === void 0) {
        data = {};
      }

      Object.keys(data).forEach(function (key) {
        return root.FCL_REGISTRY[addr].kvs[key] = data[key];
      });
    },
    fatalError: function fatalError(error) {
      root.FCL_REGISTRY[addr].error = error;

      for (var _iterator2 = _createForOfIteratorHelperLoose(root.FCL_REGISTRY[addr].subs), _step2; !(_step2 = _iterator2()).done;) {
        var to = _step2.value;

        _send(to, UPDATED);
      }
    }
  };
  if (typeof fn === "object") fn = fromHandlers(fn);
  queueMicrotask_1(function () {
    try {
      return Promise.resolve(fn(ctx)).then(function () {
        kill(addr);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
  return addr;
};

function subscriber(address, spawnFn, callback) {
  spawnFn(address);
  var EXIT = "@EXIT";
  var self = spawn(function (ctx) {
    try {
      var _exit2;

      ctx.send(address, SUBSCRIBE);
      return Promise.resolve(_for(function () {
        return !_exit2 && 1;
      }, void 0, function () {
        return Promise.resolve(ctx.receive()).then(function (letter) {
          var error = root.FCL_REGISTRY[address].error;

          if (letter.tag === EXIT) {
            ctx.send(address, UNSUBSCRIBE);
            _exit2 = 1;
            return;
          }

          if (error) {
            callback(null, error);
            ctx.send(address, UNSUBSCRIBE);
            _exit2 = 1;
            return;
          }

          callback(letter.data, null);
        });
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  });
  return function () {
    return _send(self, EXIT);
  };
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";

function _catch$1(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var _HANDLERS;

var first = function first(wants, fallback) {
  if (wants === void 0) {
    wants = [];
  }

  try {
    if (!wants.length) return Promise.resolve(fallback);

    var _wants = wants,
        head = _wants[0],
        rest = _wants.slice(1);

    return Promise.resolve(get(head)).then(function (ret) {
      return ret == null ? first(rest, fallback) : ret;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var NAME = "config";
var PUT = "PUT_CONFIG";
var GET = "GET_CONFIG";
var GET_ALL = "GET_ALL_CONFIG";
var UPDATE = "UPDATE_CONFIG";
var DELETE = "DELETE_CONFIG";
var CLEAR = "CLEAR_CONFIG";
var WHERE = "WHERE_CONFIG";
var UPDATED$1 = "CONFIG/UPDATED";

var identity = function identity(v) {
  return v;
};

var HANDLERS = (_HANDLERS = {}, _HANDLERS[PUT] = function (ctx, _letter, _ref) {
  var key = _ref.key,
      value = _ref.value;
  if (key == null) throw new Error("Missing 'key' for config/put.");
  ctx.put(key, value);
  ctx.broadcast(UPDATED$1, _extends$1({}, ctx.all()));
}, _HANDLERS[GET] = function (ctx, letter, _ref2) {
  var key = _ref2.key,
      fallback = _ref2.fallback;
  if (key == null) throw new Error("Missing 'key' for config/get");
  letter.reply(ctx.get(key, fallback));
}, _HANDLERS[GET_ALL] = function (ctx, letter) {
  letter.reply(_extends$1({}, ctx.all()));
}, _HANDLERS[UPDATE] = function (ctx, letter, _ref3) {
  var key = _ref3.key,
      fn = _ref3.fn;
  if (key == null) throw new Error("Missing 'key' for config/update");
  ctx.update(key, fn || identity);
  ctx.broadcast(UPDATED$1, _extends$1({}, ctx.all()));
}, _HANDLERS[DELETE] = function (ctx, letter, _ref4) {
  var key = _ref4.key;
  if (key == null) throw new Error("Missing 'key' for config/delete");
  ctx["delete"](key);
  ctx.broadcast(UPDATED$1, _extends$1({}, ctx.all()));
}, _HANDLERS[CLEAR] = function (ctx, letter) {
  var keys = Object.keys(ctx.all());

  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    ctx["delete"](key);
  }

  ctx.broadcast(UPDATED$1, _extends$1({}, ctx.all()));
}, _HANDLERS[WHERE] = function (ctx, letter, _ref5) {
  var pattern = _ref5.pattern;
  if (pattern == null) throw new Error("Missing 'pattern' for config/where");
  letter.reply(ctx.where(pattern));
}, _HANDLERS[SUBSCRIBE] = function (ctx, letter) {
  ctx.subscribe(letter.from);
  ctx.send(letter.from, UPDATED$1, _extends$1({}, ctx.all()));
}, _HANDLERS[UNSUBSCRIBE] = function (ctx, letter) {
  ctx.unsubscribe(letter.from);
}, _HANDLERS);
spawn(HANDLERS, NAME);

function put(key, value) {
  _send(NAME, PUT, {
    key: key,
    value: value
  });

  return config();
}

function get(key, fallback) {
  return _send(NAME, GET, {
    key: key,
    fallback: fallback
  }, {
    expectReply: true,
    timeout: 10
  });
}

function all() {
  return _send(NAME, GET_ALL, null, {
    expectReply: true,
    timeout: 10
  });
}

function update(key, fn) {
  if (fn === void 0) {
    fn = identity;
  }

  _send(NAME, UPDATE, {
    key: key,
    fn: fn
  });

  return config();
}

function _delete(key) {
  _send(NAME, DELETE, {
    key: key
  });

  return config();
}

function where(pattern) {
  return _send(NAME, WHERE, {
    pattern: pattern
  }, {
    expectReply: true,
    timeout: 10
  });
}

function subscribe(callback) {
  return subscriber(NAME, function () {
    return spawn(HANDLERS, NAME);
  }, callback);
}

function clearConfig() {
  return _send(NAME, CLEAR);
}

function config(values) {
  if (values != null && typeof values === "object") {
    Object.keys(values).map(function (d) {
      return put(d, values[d]);
    });
  }

  return {
    put: put,
    get: get,
    all: all,
    first: first,
    update: update,
    "delete": _delete,
    where: where,
    subscribe: subscribe,
    overload: overload
  };
}

config.put = put;
config.get = get;
config.all = all;
config.first = first;
config.update = update;
config["delete"] = _delete;
config.where = where;
config.subscribe = subscribe;
config.overload = overload;

var noop = function noop(v) {
  return v;
};

function overload(opts, callback) {
  if (opts === void 0) {
    opts = {};
  }

  if (callback === void 0) {
    callback = noop;
  }

  return new Promise(function (resolve, reject) {
    try {
      return Promise.resolve(all()).then(function (oldConfig) {
        var _temp = _catch$1(function () {
          config(opts);
          var _callback = callback;
          return Promise.resolve(all()).then(function (_all) {
            return Promise.resolve(_callback(_all)).then(function (result) {
              return Promise.resolve(clearConfig()).then(function () {
                return Promise.resolve(config(oldConfig)).then(function () {
                  resolve(result);
                });
              });
            });
          });
        }, function (error) {
          return Promise.resolve(clearConfig()).then(function () {
            return Promise.resolve(config(oldConfig)).then(function () {
              reject(error);
            });
          });
        });

        if (_temp && _temp.then) return _temp.then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
}

var LEVELS = Object.freeze({
  debug: 5,
  info: 4,
  log: 3,
  warn: 2,
  error: 1
});

var buildLoggerMessageArgs = function buildLoggerMessageArgs(_ref) {
  var title = _ref.title,
      message = _ref.message;
  return [("\n    %c" + title + "\n    ============================\n\n    " + message + "\n\n    ============================\n    ").replace(/\n[^\S\r\n]+/g, "\n").trim(),, "font-weight:bold;font-family:monospace;"];
};

var log = function log(_ref2) {
  var title = _ref2.title,
      message = _ref2.message,
      level = _ref2.level,
      _ref2$always = _ref2.always,
      always = _ref2$always === void 0 ? false : _ref2$always;

  try {
    return Promise.resolve(config.get("logger.level", LEVELS.warn)).then(function (configLoggerLevel) {
      var _console, _console2, _console3, _console4, _console5;

      if (!always && configLoggerLevel < level) return;
      var loggerMessageArgs = buildLoggerMessageArgs({
        title: title,
        message: message
      });

      switch (level) {
        case LEVELS.debug:
          (_console = console).debug.apply(_console, loggerMessageArgs);

          break;

        case LEVELS.info:
          (_console2 = console).info.apply(_console2, loggerMessageArgs);

          break;

        case LEVELS.warn:
          (_console3 = console).warn.apply(_console3, loggerMessageArgs);

          break;

        case LEVELS.error:
          (_console4 = console).error.apply(_console4, loggerMessageArgs);

          break;

        default:
          (_console5 = console).log.apply(_console5, loggerMessageArgs);

      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

log.deprecate = function (_ref3) {
  var pkg = _ref3.pkg,
      subject = _ref3.subject,
      transition = _ref3.transition,
      _ref3$level = _ref3.level,
      level = _ref3$level === void 0 ? LEVELS.warn : _ref3$level,
      _ref3$message = _ref3.message,
      message = _ref3$message === void 0 ? "" : _ref3$message,
      _ref3$callback = _ref3.callback,
      callback = _ref3$callback === void 0 ? null : _ref3$callback;

  var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  var logMessage = function logMessage() {
    return log({
      title: (pkg ? pkg + " " : "") + "Deprecation Notice",
      message: ("\n      " + (subject ? capitalizeFirstLetter(subject) + " is deprecated and will cease to work in future releases" + (pkg ? " of " + pkg : "") + "." : "") + (message ? "\n" + message : "") + (transition ? "\nYou can learn more (including a guide on common transition paths) here: " + transition : "") + "\n    ").trim(),
      level: level
    });
  };

  if (typeof callback === "function") {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      try {
        return Promise.resolve(logMessage()).then(function () {
          return Promise.resolve(callback.apply(void 0, args));
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
  }

  return logMessage();
};

var type = function type(label, asArgument, asInjection) {
  return {
    label: label,
    asArgument: asArgument,
    asInjection: asInjection
  };
};

var isArray = function isArray(d) {
  return Array.isArray(d);
};

var isObj = function isObj(d) {
  return typeof d === "object";
};

var isNull = function isNull(d) {
  return d == null;
};

var isBoolean = function isBoolean(d) {
  return typeof d === "boolean";
};

var isNumber = function isNumber(d) {
  return typeof d === "number";
};

var isInteger = function isInteger(d) {
  return Number.isInteger(d);
};

var isString = function isString(d) {
  return typeof d === "string";
};

var throwTypeError = function throwTypeError(msg) {
  throw new Error("Type Error: " + msg);
};

var numberValuesDeprecationNotice = function numberValuesDeprecationNotice(type) {
  log.deprecate({
    pkg: "@onflow/types",
    subject: "Passing in Number as value for " + type,
    message: "Going forward, use String as value for " + type + ".",
    transition: "https://github.com/onflow/flow-js-sdk/blob/master/packages/types/WARNINGS.md#0002-[U]Int*-and-Word*-as-Number"
  });
};

var Identity = type("Identity", function (v) {
  return v;
}, function (v) {
  return v;
});
var UInt = type("UInt", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("UInt");
    return {
      type: "UInt",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "UInt",
      value: v
    };
  }

  throwTypeError("Expected Positive Integer for type Unsigned Int");
}, function (v) {
  return v;
});
var Int = type("Int", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Int");
    return {
      type: "Int",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Int",
      value: v
    };
  }

  throwTypeError("Expected Integer for type Int");
}, function (v) {
  return v;
});
var UInt8 = type("UInt8", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("UInt8");
    return {
      type: "UInt8",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "UInt8",
      value: v
    };
  }

  throwTypeError("Expected integer for UInt8");
}, function (v) {
  return v;
});
var Int8 = type("Int8", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Int8");
    return {
      type: "Int8",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Int8",
      value: v
    };
  }

  throwTypeError("Expected positive integer for Int8");
}, function (v) {
  return v;
});
var UInt16 = type("UInt16", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("UInt16");
    return {
      type: "UInt16",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "UInt16",
      value: v
    };
  }

  throwTypeError("Expected integer for UInt16");
}, function (v) {
  return v;
});
var Int16 = type("Int16", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Int16");
    return {
      type: "Int16",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Int16",
      value: v
    };
  }

  throwTypeError("Expected positive integer for Int16");
}, function (v) {
  return v;
});
var UInt32 = type("UInt32", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("UInt32");
    return {
      type: "UInt32",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "UInt32",
      value: v
    };
  }

  throwTypeError("Expected integer for UInt32");
}, function (v) {
  return v;
});
var Int32 = type("Int32", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Int32");
    return {
      type: "Int32",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Int32",
      value: v
    };
  }

  throwTypeError("Expected positive integer for Int32");
}, function (v) {
  return v;
});
var UInt64 = type("UInt64", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("UInt64");
    return {
      type: "UInt64",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "UInt64",
      value: v
    };
  }

  throwTypeError("Expected integer for UInt64");
}, function (v) {
  return v;
});
var Int64 = type("Int64", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Int64");
    return {
      type: "Int64",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Int64",
      value: v
    };
  }

  throwTypeError("Expected positive integer for Int64");
}, function (v) {
  return v;
});
var UInt128 = type("UInt128", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("UInt128");
    return {
      type: "UInt128",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "UInt128",
      value: v
    };
  }

  throwTypeError("Expected integer for UInt128");
}, function (v) {
  return v;
});
var Int128 = type("Int128", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Int128");
    return {
      type: "Int128",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Int128",
      value: v
    };
  }

  throwTypeError("Expected positive integer for Int128");
}, function (v) {
  return v;
});
var UInt256 = type("UInt256", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("UInt256");
    return {
      type: "UInt256",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "UInt256",
      value: v
    };
  }

  throwTypeError("Expected integer for UInt256");
}, function (v) {
  return v;
});
var Int256 = type("Int256", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Int256");
    return {
      type: "Int256",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Int256",
      value: v
    };
  }

  throwTypeError("Expected integer for Int256");
}, function (v) {
  return v;
});
var Word8 = type("Word8", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Word8");
    return {
      type: "Word8",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Word8",
      value: v
    };
  }

  throwTypeError("Expected positive number for Word8");
}, function (v) {
  return v;
});
var Word16 = type("Word16", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Word16");
    return {
      type: "Word16",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Word16",
      value: v
    };
  }

  throwTypeError("Expected positive number for Word16");
}, function (v) {
  return v;
});
var Word32 = type("Word32", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Word32");
    return {
      type: "Word32",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Word32",
      value: v
    };
  }

  throwTypeError("Expected positive number for Word32");
}, function (v) {
  return v;
});
var Word64 = type("Word64", function (v) {
  if (isNumber(v) && isInteger(v)) {
    numberValuesDeprecationNotice("Word64");
    return {
      type: "Word64",
      value: v.toString()
    };
  }

  if (isString(v)) {
    return {
      type: "Word64",
      value: v
    };
  }

  throwTypeError("Expected positive number for Word64");
}, function (v) {
  return v;
});

var UFix64AndFix64NumberDeprecationNotice = function UFix64AndFix64NumberDeprecationNotice() {
  log.deprecate({
    subject: "Passing in Numbers as values for Fix64 and UFix64 types",
    pkg: "@onflow/types",
    transition: "https://github.com/onflow/flow-js-sdk/blob/master/packages/types/WARNINGS.md#0001-[U]Fix64-as-Number"
  });
};

var UFix64 = type("UFix64", function (v) {
  if (isString(v)) {
    var vParts = v.split(".");

    if (vParts.length !== 2) {
      throwTypeError("Expected one decimal but found " + vParts.length + " in the [U]Fix64 value. Find out more about [U]Fix64 types here: https://docs.onflow.org/cadence/json-cadence-spec/#fixed-point-numbers");
    }

    if (vParts[1].length == 0 || vParts[1].length > 8) {
      throwTypeError("Expected at least one digit, and at most 8 digits following the decimal of the [U]Fix64 value but found " + vParts[1].length + " digits. Find out more about [U]Fix64 types here: https://docs.onflow.org/cadence/json-cadence-spec/#fixed-point-numbers");
    }

    vParts[1] = vParts[1].padEnd(8, "0");
    v = vParts.join(".");
    return {
      type: "UFix64",
      value: v
    };
  } else if (isNumber(v)) {
    UFix64AndFix64NumberDeprecationNotice();
    return {
      type: "UFix64",
      value: v.toString()
    };
  }

  throwTypeError("Expected String for UFix64");
}, function (v) {
  return v;
});
var Fix64 = type("Fix64", function (v) {
  if (isString(v)) {
    var vParts = v.split(".");

    if (vParts.length !== 2) {
      throwTypeError("Expected one decimal but found " + vParts.length + " in the [U]Fix64 value. Find out more about [U]Fix64 types here: https://docs.onflow.org/cadence/json-cadence-spec/#fixed-point-numbers");
    }

    if (vParts[1].length == 0 || vParts[1].length > 8) {
      throwTypeError("Expected at least one digit, and at most 8 digits following the decimal of the [U]Fix64 value but found " + vParts[1].length + " digits. Find out more about [U]Fix64 types here: https://docs.onflow.org/cadence/json-cadence-spec/#fixed-point-numbers");
    }

    vParts[1] = vParts[1].padEnd(8, "0");
    v = vParts.join(".");
    return {
      type: "Fix64",
      value: v
    };
  } else if (isNumber(v)) {
    UFix64AndFix64NumberDeprecationNotice();
    return {
      type: "Fix64",
      value: v.toString()
    };
  }

  throwTypeError("Expected String for Fix64");
}, function (v) {
  return v;
});
var String = type("String", function (v) {
  if (isString(v)) return {
    type: "String",
    value: v
  };
  throwTypeError("Expected String for type String");
}, function (v) {
  return v;
});
var Character = type("Character", function (v) {
  if (isString(v)) return {
    type: "Character",
    value: v
  };
  throwTypeError("Expected Character for type Character");
}, function (v) {
  return v;
});
var Bool = type("Bool", function (v) {
  if (isBoolean(v)) return {
    type: "Bool",
    value: v
  };
  throwTypeError("Expected Boolean for type Bool");
}, function (v) {
  return v;
});
var Address = type("Address", function (v) {
  if (isString(v)) return {
    type: "Address",
    value: v
  };
  throwTypeError("Expected Address for type Address");
}, function (v) {
  return v;
});
var Void = type("Void", function (v) {
  if (!v || isNull(v)) return {
    type: "Void"
  };
  throwTypeError("Expected Void for type Void");
}, function (v) {
  return v;
});
var Optional = function Optional(children) {
  return type("Optional", function (v) {
    return {
      type: "Optional",
      value: isNull(v) ? null : children.asArgument(v)
    };
  }, function (v) {
    return v;
  });
};
var Reference = type("Reference", function (v) {
  if (isObj(v)) return {
    type: "Reference",
    value: v
  };
  throwTypeError("Expected Object for type Reference");
}, function (v) {
  return v;
});
var _Array = function _Array(children) {
  if (children === void 0) {
    children = [];
  }

  return type("Array", function (v) {
    return {
      type: "Array",
      value: isArray(children) ? children.map(function (c, i) {
        return c.asArgument(v[i]);
      }) : v.map(function (x) {
        return children.asArgument(x);
      })
    };
  }, function (v) {
    return v;
  });
};
var Dictionary = function Dictionary(children) {
  if (children === void 0) {
    children = [];
  }

  return type("Dictionary", function (v) {
    if (isObj(v)) return {
      type: "Dictionary",
      value: isArray(children) ? children.map(function (c, i) {
        return {
          key: c.key.asArgument(v[i].key),
          value: c.value.asArgument(v[i].value)
        };
      }) : isArray(v) ? v.map(function (x) {
        return {
          key: children.key.asArgument(x.key),
          value: children.value.asArgument(x.value)
        };
      }) : [{
        key: children.key.asArgument(v.key),
        value: children.value.asArgument(v.value)
      }]
    };
    throwTypeError("Expected Object for type Dictionary");
  }, function (v) {
    return v;
  });
};
var Event = function Event(id, fields) {
  if (fields === void 0) {
    fields = [];
  }

  return type("Event", function (v) {
    if (isObj(v)) return {
      type: "Event",
      value: {
        id: id,
        fields: isArray(fields) ? fields.map(function (c, i) {
          return {
            name: v.fields[i].name,
            value: c.value.asArgument(v.fields[i].value)
          };
        }) : v.fields.map(function (x) {
          return {
            name: x.name,
            value: fields.value.asArgument(x.value)
          };
        })
      }
    };
    throwTypeError("Expected Object for type Event");
  }, function (v) {
    return v;
  });
};
var Resource = function Resource(id, fields) {
  if (fields === void 0) {
    fields = [];
  }

  return type("Resource", function (v) {
    if (isObj(v)) return {
      type: "Resource",
      value: {
        id: id,
        fields: isArray(fields) ? fields.map(function (c, i) {
          return {
            name: v.fields[i].name,
            value: c.value.asArgument(v.fields[i].value)
          };
        }) : v.fields.map(function (x) {
          return {
            name: x.name,
            value: fields.value.asArgument(x.value)
          };
        })
      }
    };
    throwTypeError("Expected Object for type Resource");
  }, function (v) {
    return v;
  });
};
var Struct = function Struct(id, fields) {
  if (fields === void 0) {
    fields = [];
  }

  return type("Struct", function (v) {
    if (isObj(v)) return {
      type: "Struct",
      value: {
        id: id,
        fields: isArray(fields) ? fields.map(function (c, i) {
          return {
            name: v.fields[i].name,
            value: c.value.asArgument(v.fields[i].value)
          };
        }) : v.fields.map(function (x) {
          return {
            name: x.name,
            value: fields.value.asArgument(x.value)
          };
        })
      }
    };
    throwTypeError("Expected Object for type Struct");
  }, function (v) {
    return v;
  });
};
var Path = type("Path", function (v) {
  if (isObj(v)) {
    if (!isString(v.domain)) {
      throwTypeError("Expected a string for the Path domain but found " + v.domain + ". Find out more about the Path type here: https://docs.onflow.org/cadence/json-cadence-spec/#path");
    }

    if (!(v.domain === "storage" || v.domain === "private" || v.domain === "public")) {
      throwTypeError("Expected either \"storage\", \"private\" or \"public\" as the Path domain but found " + v.domain + ". Find out more about the Path type here: https://docs.onflow.org/cadence/json-cadence-spec/#path");
    }

    if (!isString(v.identifier)) {
      throwTypeError("Expected a string for the Path identifier but found " + v.identifier + ". Find out more about the Path type here: https://docs.onflow.org/cadence/json-cadence-spec/#path");
    }

    return {
      type: "Path",
      value: {
        domain: v.domain,
        identifier: v.identifier
      }
    };
  }

  throwTypeError("Expected Object for type Path");
}, function (v) {
  return v;
});

export { Address, _Array as Array, Bool, Character, Dictionary, Event, Fix64, Identity, Int, Int128, Int16, Int256, Int32, Int64, Int8, Optional, Path, Reference, Resource, String, Struct, UFix64, UInt, UInt128, UInt16, UInt256, UInt32, UInt64, UInt8, Void, Word16, Word32, Word64, Word8, _Array };
//# sourceMappingURL=types.module.js.map
